define('NVT.anuualupdateform.purpose_of_appointing_auth_rep.View'
, [
    'Backbone'
  , 'nvt_purpose_of_appointing_auth_rep.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_purpose_of_appointing_auth_rep_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_purpose_of_appointing_auth_rep_tpl

       , title: Utils.translate('Purpose of AR')


        ,initialize: function(options)
            {
                //this.model.on('sync', _.bind(this.render, this));
                this.options = options;
                this.profile= options.profile;
                this.application = options.application;
                this.page_header = Utils.translate('Purpose of AR');
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }
            
        ,getContext: function() {
            
            return {
               title : this.page_header
              
           }
         }        

    });
});
